const canvasSketch = require('canvas-sketch');
import gsap from 'gsap'
import random from 'canvas-sketch-util/random';
const API_KEY = '7A00fW4rncGAg9jvyKML';
const varition = [
  0,0,0,0,0,0,0,
  0,
  0.4,
  1.4,
  0.9,
  0.3,
  0.2,
  0.15,
  0.05,
  0.04,
  0.03,
  0.028,
  0.025,
  0.01,
  0.005,
]


//canvas-sketch app.js --html=index.html --build --dir build/

const locations = [

 { lat:48.86379101, lng:2.32469568, zoom: 17}, // paris inner
 { lat:48.95493172, lng:2.30737587, zoom: 16}, // paris outer

 { lat: 51.52259545, lng:-0.08771509, zoom: 13}, //london

  { lat:   56.84448838, lng:-5.16020772, zoom: 12}, //scotland

  { lat:   61.12315776, lng:6.75839219, zoom: 10}, //norway

  { lat:   46.48175111, lng:8.09184918, zoom: 13}, //alps

  { lat:38.78902172, lng:-1.49109055, zoom: 12},

  { lat:38.97467604, lng:-1.72665767, zoom: 15 },


   { lat:4.88495209, lng:36.09833774, zoom: 12 }, //kenya

   { lat:8.58625876, lng:44.24727399, zoom: 12 }, //chad


   { lat:14.2151686, lng:38.97646346, zoom: 13 }, //ethiopia


   { lat:30.79022453, lng:31.00912783, zoom: 13 }, //nile delta


   { lat:30.45671242, lng:30.14060362, zoom: 13 }, //lybia
   { lat:30.45671242, lng:30.14060362, zoom: 12 }, //lybia



   { lat:27.81624513, lng:10.17180016, zoom: 13 }, //sahara
   { lat:27.81624513, lng:10.17180016, zoom: 9 }, //sahara


   { lat:30.57229839, lng:-6.5548169, zoom: 13 }, //morocco
   { lat:30.57229839, lng:-6.5548169, zoom: 9 }, //morocco


   { lat:19.57560718, lng:-13.13882287, zoom: 9 }, //w sahara
   { lat:19.57560718, lng:-13.13882287, zoom: 12 }, //w sahara

   

   { lat:40.72668107, lng:-73.99346567, zoom: 17 }, //NY
   { lat:40.74135094, lng:-73.96895644, zoom: 16 }, //NY


   { lat:40.37423116, lng:-87.57232231, zoom: 12 }, //mid west

   { lat:37.945692, lng:-109.94986056, zoom: 10 }, //rockies
   { lat:37.945692, lng:-109.94986056, zoom: 13 }, //rockies

   { lat:34.063403, lng:-118.04478475, zoom: 15 }, //LA
   { lat:34.07583163, lng:-118.23563424, zoom: 15 }, //LA


   { lat:33.66921839, lng:-116.14376322, zoom: 14 }, //mexico
   { lat:32.52285301, lng:-115.06661881, zoom: 13 }, //mexico

 
   { lat:-8.82450692, lng:-77.62763739, zoom: 13 }, //andies
   { lat:-18.95308051, lng:-65.37001765, zoom: 12 }, //andies



   { lat:43.8923436, lng:11.08952144, zoom: 14}, // italy
   { lat:41.92737688, lng:12.51709668, zoom: 14}, // italy

  { lng:132.837444, lat:-24.137734, zoom: 10 },  // outback red
  { lng:138.224611, lat:-27.301995, zoom: 12 }, // outback yellow

  { lng:128.349530, lat:-15.501423, zoom: 12 },  //sandy river


  // --- built landscapes ---

  { lat:41.41000000, lng:2.16000000, zoom: 17 }, //barcelona eixample grid
  { lat:52.37800000, lng:4.88500000, zoom: 16 }, //amsterdam canal rings
  { lat:45.44200000, lng:12.33000000, zoom: 16 }, //venice
  { lat:45.90500000, lng:13.31000000, zoom: 16 }, //palmanova star fort
  { lat:35.69500000, lng:139.70000000, zoom: 16 }, //tokyo shinjuku
  { lat:22.32500000, lng:114.17000000, zoom: 16 }, //hong kong kowloon
  { lat:30.06000000, lng:31.24000000, zoom: 16 }, //cairo
  { lat:19.43500000, lng:-99.13000000, zoom: 15 }, //mexico city
  { lat:25.12500000, lng:55.13500000, zoom: 14 }, //dubai palm jumeirah
  { lat:33.62000000, lng:-112.28000000, zoom: 15 }, //sun city arizona circles
  { lat:36.78000000, lng:-2.82000000, zoom: 14 }, //almeria greenhouses


  // --- rural textures ---

  { lat:52.27000000, lng:4.55000000, zoom: 15 }, //dutch bulb fields
  { lat:43.07000000, lng:11.67000000, zoom: 14 }, //tuscany val d'orcia
  { lat:46.86000000, lng:-117.30000000, zoom: 13 }, //palouse wheat hills
  { lat:37.97000000, lng:-100.87000000, zoom: 12 }, //kansas centre pivots
  { lat:30.10000000, lng:38.26000000, zoom: 12 }, //saudi centre pivots
  { lat:-16.90000000, lng:-62.50000000, zoom: 11 }, //bolivia radial farms


  // --- natural textures ---

  { lat:-2.53000000, lng:-43.12000000, zoom: 13 }, //lencois maranhenses dunes
  { lat:-24.73000000, lng:15.35000000, zoom: 12 }, //namib dunes
  { lat:21.90000000, lng:89.20000000, zoom: 11 }, //sundarbans
  { lat:-15.90000000, lng:46.35000000, zoom: 11 }, //betsiboka estuary


  // --- ocean ---
  // zooms are tight so the column (18 tiles south of the start) stays over shallow water

  { lat:4.45000000, lng:73.45000000, zoom: 11 }, //maldives atolls
  { lat:23.75000000, lng:-76.45000000, zoom: 13 }, //exuma sand waves
  { lat:-16.47000000, lng:-151.75000000, zoom: 16 }, //bora bora
  { lat:-18.86000000, lng:-159.78000000, zoom: 16 }, //aitutaki
  { lat:17.50000000, lng:-87.55000000, zoom: 14 }, //lighthouse reef blue hole
  { lat:11.90000000, lng:-66.70000000, zoom: 15 }, //los roques
  { lat:-12.10000000, lng:96.86000000, zoom: 16 }, //cocos keeling
  { lat:53.75000000, lng:8.40000000, zoom: 14 }, //wadden sea
  { lat:-25.85000000, lng:113.95000000, zoom: 13 }, //shark bay
  { lat:-21.55000000, lng:35.45000000, zoom: 13 }, //bazaruto


]


function shiftLocation(loc){
  let newLocation = {...loc}
  let fuzz = varition[loc.zoom]
  newLocation.lat += 0.75*fuzz*Math.random() - fuzz*0.5
  newLocation.lng += 1.25 * (fuzz*Math.random() - fuzz*0.5)
  return newLocation;

}

function lon2tile(lon, zoom) { return (Math.floor((lon + 180) / 360 * Math.pow(2, zoom))); }
function lat2tile(lat, zoom) { return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom))); }

function tile2long(x, z) { return (x / Math.pow(2, z) * 360 - 180); }
function tile2lat(y, z) {
  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
  return (180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))));
}


const NUM_STRIPS = 6;
// on narrow windows strips are cropped to a thinner slice so at least this many fit across
const MIN_VISIBLE_STRIPS = 4;
let size = 512;


// the scene is laid out at this fixed size, then scaled to cover the window
const DESIGN_WIDTH = NUM_STRIPS*size;
const DESIGN_HEIGHT = DESIGN_WIDTH*0.5;

const settings = {
  // no dimensions: canvas-sketch sizes the canvas to the window and tracks resizes
  animate: true,
  duration: 1,
};


//let tiles = [[]]



const strip = {
  lat:0,
  lng:0,
  zoom:0,
  width:200,
  height:2000,
  length:2000,
  x:0,
  y:0,
  ready:false,
  tiles:[]
}

const strips = []



const overlay = new Image();
overlay.src="./overlay.png";

const scrollEase = gsap.parseEase("sine.inOut");

// strip offset at a given point (0-1) through its scroll
const scrollY = (progress) => (strip.height - strip.length) * scrollEase(progress);

// start downloading a strip's tiles for a location, beginning with the rows on screen at startY.
// `top` resolves once those rows are decoded, `all` once every tile is.
const loadTiles = (loc, startY = 0) => {

  const z = loc.zoom;
  const x = lon2tile(loc.lng, z)
  const y = lat2tile(loc.lat, z)

  const tilesWidth = Math.ceil(strip.width / size);
  const tilesHeight = Math.ceil(strip.length / size);
  const visibleRows = Math.ceil(strip.height / size) + 1;
  const firstRow = Math.floor(-startY / size);
  const isVisible = (j) => j >= firstRow && j < firstRow + visibleRows;

  const tiles = [];
  for (var i = 0; i < tilesWidth; i++) tiles.push([]);

  const loadRows = (rows) => {
    const decoded = [];
    for (var i = 0; i < tilesWidth; i++) {
      rows.forEach((j) => {
        var tile = new Image(size, size);
        tile.src = `https://api.maptiler.com/tiles/satellite-v2/${z}/${x + i}/${y + j}.jpg?key=${API_KEY}`;
        //tile.src = `https://api.maptiler.com/tiles/uk-osgb63k1885/${z}/${x + i}/${y + j}.png?key=${API_KEY}`;
        tiles[i][j] = tile;
        // decode() also decodes off the main thread, so first draw doesn't stutter
        decoded.push(tile.decode());
      });
    }
    return Promise.allSettled(decoded);
  }

  const rows = [...Array(tilesHeight).keys()];
  const top = loadRows(rows.filter(isVisible));
  // hold off the rest so on-screen tiles across all strips download first
  const all = top.then(() => loadRows(rows.filter((j) => !isVisible(j))));

  return { tiles, top, all }
}

const nextLocation = () => shiftLocation(random.pick(locations));

// show a loaded set of tiles, scroll through it, and prefetch the next location meanwhile
const runStrip = (strip, load, startProgress = 0) => {

  load.top.then(() => {
    strip.tiles = load.tiles;
    strip.y = 0;
    strip.ready = true;

    // wait for this strip to finish so the prefetch doesn't compete with it
    let next;
    load.all.then(() => { next = loadTiles(nextLocation()) });

    gsap.to(strip, {
      y: strip.height - strip.length,
      duration:120,
      //ease:"linear",
      ease:scrollEase,
      onComplete:()=>{
        runStrip(strip, next || loadTiles(nextLocation()))
      }}).progress(startProgress);
  });
}


const sketch = () => {

  // offscreen canvas the scene is composed into before being scaled to the window
  const bufferCanvas = document.createElement('canvas');
  bufferCanvas.width = DESIGN_WIDTH;
  bufferCanvas.height = DESIGN_HEIGHT;
  const buffer = bufferCanvas.getContext('2d');

  random.setSeed(0)
  strip.width = DESIGN_WIDTH / NUM_STRIPS;
  strip.height = DESIGN_HEIGHT;
  strip.length = DESIGN_HEIGHT*6;

  for( let i = 0; i<NUM_STRIPS; i++ ){
    let loc = random.pick(locations)
    loc = shiftLocation(loc);

    strips.push( {...strip, ...loc, x:strip.width*i}, )
  }

  // start every strip at once, each part-way through its first scroll so they change location at different times
  strips.forEach( ( s, index )=>{
    const startProgress = index / NUM_STRIPS;
    runStrip(s, loadTiles(s, scrollY(startProgress)), startProgress)
  })

  return {
    // Handle resize events here
    resize({}) {
    },
    // Update & render your scene here
    render({ context, width, height }) {
      //console.log("render...")
      context.fillStyle = 'black';
      context.fillRect(0, 0, width, height);

      // scale that makes the frame cover the window, cropping whichever axis overflows
      const scale = Math.max(width / DESIGN_WIDTH, height / DESIGN_HEIGHT);

      // width of each strip in design px: full width normally, a centred slice of it when
      // the window is too narrow to show MIN_VISIBLE_STRIPS full strips
      const slotWidth = Math.min(size, Math.floor(width / (MIN_VISIBLE_STRIPS * scale)));
      const cropX = Math.floor((size - slotWidth) / 2);
      const frameWidth = slotWidth * NUM_STRIPS;

      // draw at design size on whole pixels so tiles butt together without seams
      buffer.fillStyle = 'black';
      buffer.fillRect(0, 0, DESIGN_WIDTH, DESIGN_HEIGHT);

      strips.forEach( ( s, k )=>{
        if(s.ready){
          const slotX = k * slotWidth;
          let tiles = s.tiles;
          const y = Math.round(s.y);

          buffer.save();
          buffer.beginPath();
          buffer.rect(slotX, 0, slotWidth, DESIGN_HEIGHT);
          buffer.clip();
          for (var i = 0; i < tiles.length; i++) {
            for (var j = 0; j < tiles[i].length; j++) {
              const tile = tiles[i][j];
              // lower tiles may still be loading, and a failed tile is "broken" and would throw
              if (tile.complete && tile.naturalWidth > 0) {
                buffer.drawImage(tile, slotX - cropX + i * size, y + j * size, size, size);
              }
            }
          }
          buffer.restore();
        }
      })

      // skip the overlay if overlay.png is missing or hasn't loaded yet.
      // it's an edge vignette, so it's squeezed to the slot rather than cropped
      if (overlay.complete && overlay.naturalWidth > 0) {
        strips.forEach( ( s, k )=>{
          buffer.drawImage(overlay, k * slotWidth, 0, slotWidth, s.height);
        })
      }

      // scale the finished frame to the window, centred
      context.drawImage(
        buffer.canvas,
        0, 0, frameWidth, DESIGN_HEIGHT,
        (width - frameWidth*scale) / 2,
        (height - DESIGN_HEIGHT*scale) / 2,
        frameWidth*scale,
        DESIGN_HEIGHT*scale
      );


    },
    // Dispose of events & renderer for cleaner hot-reloading
    unload() {
    }
  }

};

canvasSketch(sketch, settings);
